export default class APIDashboard {
  constructor(API) {
    this.api = API;
  }

  async getStats({ programID, fromDate, toDate }) {
    const req = await this.api.newBaseRequest('POST', this.api.config.statsEndpoint);
    req.baseURL = this.api.config.statsEndpoint;
    req.path = `/dashboard/${programID}`;
    req.body = { fromDate, toDate };
    return await req.exec();
  }

  async getStatsV2({ programID, fromDate, toDate }) {
    const req = await this.api.newBaseRequest('POST', this.api.config.statsEndpoint);
    req.baseURL = this.api.config.statsEndpoint;
    req.path = `/v2/dashboard/${programID}`;
    req.body = { fromDate, toDate };
    return await req.exec();
  }
}
